import { RefObject, useEffect } from 'react';

export function useClickOutside(
  ref: RefObject<HTMLElement>,
  handler: () => void,
  enabled = true,
  ignoreElements: RefObject<HTMLElement>[] = [],
) {
  useEffect(() => {
    if (!enabled) return undefined;

    const listener = (event: MouseEvent | TouchEvent) => {
      if (
        !ref.current ||
        ref.current.contains(event.target as Node) ||
        ignoreElements.some(el => el.current?.contains(event.target as Node))
      ) {
        return;
      }
      handler();
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler, enabled, ignoreElements]);
}
